module.exports = __webpack_public_path__ + "img/C11-haiti.60b0a979.png";